/**
 * Shared helpers for standard API envelopes:
 * { operationStatus, operationMessage, data, message }
 */
export function getApiErrorMessage(source: any, fallback: string): string {
  if (!source) {
    return fallback;
  }
  if (typeof source === 'string') {
    return source.trim() || fallback;
  }

  const body = source.error !== undefined ? source.error : source;
  if (typeof body === 'string') {
    return body.trim() || fallback;
  }

  if (body && typeof body === 'object') {
    if (body.operationMessage) {
      return body.operationMessage;
    }
    if (typeof body.data === 'string' && body.data.trim()) {
      return body.data;
    }
    if (body.message) {
      return body.message;
    }
  }

  if (typeof source.message === 'string' && source.message.trim()) {
    return source.message;
  }

  return fallback;
}

/** True when a response body represents a failed API call (including some error bodies on HTTP 200). */
export function isApiErrorResponse(response: any): boolean {
  if (!response) {
    return true;
  }
  if (response.operationStatus === 'ERROR') {
    return true;
  }
  if (response.operationStatus && response.operationStatus !== 'SUCCESS') {
    return true;
  }
  if (typeof response.data === 'string' && response.data.trim()) {
    return true;
  }
  return false;
}
